import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Eye, Flame, MessageSquare, Bookmark } from "lucide-react";
import { api } from "@/lib/api";

/** "People are looking" — weekly proof for free-tier sellers, pointing at the plan. */
export function ProofCard() {
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/seller/proof").then(({ data }) => setP(data)).catch(() => {}); }, []);
  if (!p || p.listings === 0 || p.sell?.can_sell) return null;
  const looks = p.views + p.impressions;
  const stats = [
    { icon: Eye, v: p.views, l: "product views" }, { icon: Flame, v: p.impressions, l: "feed appearances" },
    { icon: Bookmark, v: p.saves, l: "saves" }, { icon: MessageSquare, v: p.enquiries, l: "asked to buy", hot: true },
  ];
  return (
    <div data-testid="proof-card" className="mt-6 rounded-xl border border-[#FF3B30]/40 bg-[#FF3B30]/[0.06] p-5">
      <div className="flex flex-col md:flex-row md:items-center gap-5">
        <div className="flex-1">
          <div className="text-[11px] uppercase tracking-widest text-[#FF3B30] font-bold">Last {p.days} days</div>
          <div className="mt-1 text-xl font-black text-white" data-testid="proof-headline">
            {looks > 0 ? `${looks} views of your products` : "Your products are live in the feed"}{p.enquiries > 0 ? ` — ${p.enquiries} asked to buy` : ""}
          </div>
          <p className="mt-1 text-sm text-neutral-300">They can only enquire for now. Switch on <span className="text-white font-semibold">Buy now</span> and keep 99.5% of every sale.</p>
          {p.top && <p className="mt-1 text-xs text-neutral-400">Most viewed: <Link to={`/product/${p.top.id}`} className="text-white underline">{p.top.title}</Link> · {p.top.views} views</p>}
        </div>
        <div className="grid grid-cols-4 gap-2 md:w-80">
          {stats.map((s) => (
            <div key={s.l} className="rounded-lg bg-black/40 border border-white/10 p-2 text-center" data-testid={`proof-${s.l.replace(/\s/g, "-")}`}>
              <s.icon className={`h-4 w-4 mx-auto ${s.hot ? "text-[#FF3B30]" : "text-neutral-400"}`} />
              <div className="mt-1 font-black text-white text-lg leading-none">{s.v}</div>
              <div className="text-[10px] text-neutral-500 mt-0.5 leading-tight">{s.l}</div>
            </div>
          ))}
        </div>
        <Link to="/billing" data-testid="proof-cta" className="shrink-0 inline-flex items-center justify-center h-11 px-5 rounded-full bg-[#FF3B30] hover:bg-[#E03126] text-white font-bold text-sm transition-colors">Switch on Buy now</Link>
      </div>
    </div>
  );
}
